import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router';

const routes: Array<RouteRecordRaw> = [
    {
        path: '/',
        name: 'main',
        component: () => import('../views/Main.vue'),
        children: [
            {
                path: '/',
                component: () => import('../components/tires/Tires.vue'),
            },
            {
                path: '/tires-view',
                component: () => import('../components/entities/EntitiesView.vue'),
            },
            {
                path: '/cargo-tires',
                component: () => import('../components/entities/EntitiesView.vue'),
            },
            {
                path: '/wheel-disks',
                component: () => import('../components/entities/EntitiesView.vue'),
            },
            {
                path: '/accumulator-batteries',
                component: () => import('../components/entities/EntitiesView.vue'),
            },
            {
                path: '/centering-rings',
                component: () => import('../components/entities/EntitiesView.vue'),
            },
            {
                path: '/auto-mats',
                component: () => import('../components/goods/Mats.vue'),
            },
            {
                path: '/auto-cases',
                component: () => import('../components/goods/Cases.vue'),
            },
            {
                path: '/screw',
                component: () => import('../components/entities/EntitiesView.vue'),
            },
            {
                path: '/how-to-buy',
                component: () => import('../components/buyer/HowBuy.vue'),
            },
            {
                path: '/delivery',
                component: () => import('../components/buyer/Delivery.vue'),
            },
            {
                path: '/bonuses',
                component: () => import('../components/buyer/Bonuses.vue'),
            },
            {
                path: '/guaranty',
                component: () => import('../components/buyer/Guaranty.vue'),
            },
            {
                path: '/installment',
                component: () => import('../components/buyer/Installment.vue'),
            },
            {
                path: '/about',
                component: () => import('../components/about/About.vue'),
            },
            {
                path: '/view-entity/:_id',
                name: 'viewEntity',
                component: () => import('../components/entities/ViewEntity.vue'),
            },
            {
                path: '/bucket',
                name: 'bucket',
                component: () => import('../components/personal-orders/bucket/BucketComponent.vue'),
            },
            {
                path: '/personal',
                name: 'personal',
                component: () =>
                    import('../components/personal-orders/personal/PersonalComponent.vue'),
            },
            {
                path: '/orders-history',
                name: 'ordersHistory',
                component: () => import('../components/personal-orders/history/OrdersHistory.vue'),
            },
        ],
    },
];

const router = createRouter({
    history: createWebHashHistory(),
    // history: createWebHistory(),
    routes,
});

export default router;
